<div class="step-products">
  @if (hasError) {
    <pl-alert color="error" display="block">
      <span header>{{ errorMessage?.title }}</span>
      <span content>
        {{ errorMessage?.description }}
      </span>
    </pl-alert>
  }

  <div class="step-products__subtitle">
    {{ subtitle ?? 'Confira aqui a lista de produtos habilitados a partir do usuário existente. Esta etapa é apenas para consulta.' }}
  </div>

  @if (pmeLimitReached) {
    <div class="limit-reached-banner" role="alert" aria-live="polite">
      <span class="limit-reached-banner__icon" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M19.0706 19.0711C17.6721 20.4696 15.8903 21.422 13.9505 21.8079C12.0107 22.1937 9.99999 21.9957 8.17273 21.2388C6.34547 20.4819 4.78368 19.2002 3.68487 17.5557C2.58605 15.9112 1.99956 13.9778 1.99956 12C1.99956 10.0222 2.58605 8.08879 3.68487 6.4443C4.78368 4.79981 6.34547 3.51808 8.17273 2.7612C9.99999 2.00433 12.0107 1.8063 13.9505 2.19215C15.8903 2.578 17.6721 3.53041 19.0706 4.92893C20.9433 6.80572 21.995 9.34873 21.995 12C21.995 14.6513 20.9433 17.1943 19.0706 19.0711ZM8.46403 14.1213C8.27649 14.3089 8.17114 14.5632 8.17114 14.8284C8.17114 15.0936 8.27649 15.348 8.46403 15.5355C8.65157 15.7231 8.90592 15.8284 9.17114 15.8284C9.43635 15.8284 9.69071 15.7231 9.87824 15.5355L11.9996 13.4142L14.1209 15.5355C14.3084 15.7231 14.5628 15.8284 14.828 15.8284C15.0932 15.8284 15.3476 15.7231 15.5351 15.5355C15.7226 15.348 15.828 15.0936 15.828 14.8284C15.828 14.5632 15.7226 14.3089 15.5351 14.1213L13.4138 12L15.5351 9.87868C15.7226 9.69114 15.828 9.43679 15.828 9.17157C15.828 8.90636 15.7226 8.652 15.5351 8.46447C15.3476 8.27693 15.0932 8.17157 14.828 8.17157C14.5628 8.17157 14.3084 8.27693 14.1209 8.46447L11.9996 10.5858L9.87824 8.46447C9.69071 8.27693 9.43635 8.17157 9.17114 8.17157C8.90592 8.17157 8.65157 8.27693 8.46403 8.46447C8.27649 8.652 8.17114 8.90636 8.17114 9.17157C8.17114 9.43679 8.27649 9.69114 8.46403 9.87868L10.5854 12L8.46403 14.1213Z" fill="#D0141A"/>
        </svg>
      </span>
      <div class="limit-reached-banner__content">
        <strong>Limite de acessos atingido</strong>
        <span>
          Revise os acessos existentes e exclua os que não forem necessários para criar novos usuários.
        </span>
      </div>
    </div>
  }

  @if (cloneableLogon?.logon; as logon) {
    @if (logon.productCategories?.length) {
      <div class="step-products__user-info">
        <div class="step-products__user-info__card">
          @for (category of logon.productCategories; track $index) {
            <div class="step-products__user-info__card__content">
              <span class="step-products__user-info__card__content__name">
                {{ category?.name }}
              </span>
              @for (product of category?.products; track $index) {
                <span class="step-products__user-info__card__content__description">
                  {{ product?.name }}
                </span>
              }
            </div>
          }
        </div>
      </div>
    } @else {
      <seds-alert-basic
        color="default"
        display="block"
        headerTitle="Este acesso não tem produtos ou serviços habilitados aqui"
        [contentText]="contentTextForInformation ?? 'O usuário selecionado para cópia não possui produtos ou serviços habilitados. Verifique se este usuário tem acesso a algum produto ou serviço antes de prosseguir.'"
      ></seds-alert-basic>
    }
  }
</div>